import React from 'react'
import './Projects.css'
import {Swiper, SwiperSlide} from 'swiper/react'
import SA from "../../img/SA.webp"
import HopeFrontCover from "../../img/HopeFrontCover.webp"
import HopeBackCover from "../../img/HopeBack Cover.webp"
import SafeSpaceFront from "../../img/SafeSpaceFront.webp"
import SafeSpaceBack from "../../img/SafeSpaceBack.webp"
import FaithPack from "../../img/FaithPack.webp"
import IOM from "../../img/IOM.webp"
import PursuitOfPurpose from "../../img/PursuitOfPurpose.webp"
import vinyl from "../../img/vinyl.png"
import "swiper/css"

const projectSlides = [
    { id: 'faithpack', title: 'Faith Pack', link: 'https://www.submithub.com/link/kushim-faithpack', image: FaithPack },
    { id: 'IOM', title: 'Instruments Of Meditation', link: 'https://www.submithub.com/link/kushim-intrumentsofmeditation', image: IOM },
    { id: 'set-apart', title: 'Set Apart', link: 'https://www.submithub.com/link/kushim-setapart', image: SA },
    { id: 'pursuit-of-purpose', title: 'Pursuit Of Purpose (EP)', link: 'https://www.submithub.com/link/kushim-pursuitofpurpose', image: PursuitOfPurpose },
]

const Projects = () => {
  return (
    <div className='projects'>
        {/* heading */}
        <span>Some Recent</span>
        <span>Projects</span>

        {/* heading */}
        <Swiper
        spaceBetween={-8}
        slidesPerView={2}
        breakpoints={{
            480: { slidesPerView: 2.2, spaceBetween: -8 },
            640: { slidesPerView: 2.5, spaceBetween: 24 },
            900: { slidesPerView: 3.2, spaceBetween: 32 },
            1200: { slidesPerView: 4, spaceBetween: 50 },
        }}
        grabCursor={true}
        className="projects-slider">

            <SwiperSlide>
                <div className='project-card project-card--placeholder project-card--active'>
                    <a href='https://www.submithub.com/link/kushim-safespace' target="_blank" rel="noopener noreferrer" className='project-card__link'>
                        <div className='project-card__inner'>
                            <div className='project-card__face project-card__face--front'>
                                <img className='project-card__image' src={SafeSpaceFront} alt='SafeSpace Front Cover' loading='lazy' />
                            </div>
                            <div className='project-card__face project-card__face--back project-card__face--cover'>
                                <img className='project-card__image project-card__image--back' src={SafeSpaceBack} alt='SafeSpace Back Cover' loading='lazy' />
                            </div>
                        </div>
                    </a>
                </div>
            </SwiperSlide>

            <SwiperSlide>
                <div className='project-card project-card--placeholder project-card--active'>
                    <a href='https://www.submithub.com/link/kushim-hope' target="_blank" rel="noopener noreferrer" className='project-card__link'>
                        <div className='project-card__inner'>
                            <div className='project-card__face project-card__face--front'>
                                <img className='project-card__image' src={HopeFrontCover} alt='Hope Front Cover' loading='lazy' />
                            </div>
                            <div className='project-card__face project-card__face--back project-card__face--cover'>
                                <img className='project-card__image project-card__image--back' src={HopeBackCover} alt='Hope Back Cover' loading='lazy' />
                            </div>
                        </div>
                    </a>
                </div>
            </SwiperSlide>

            {projectSlides.map((project) => (
                <SwiperSlide key={project.id}>
                    <div className='project-card'>
                        <a href={project.link} target="_blank" rel="noopener noreferrer" className='project-card__link'>
                            <div className='project-card__inner'>
                                <div className='project-card__face project-card__face--front'>
                                    <img
                                        className={`project-card__image${project.id === 'pursuit-of-purpose' ? ' project-card__image--square-crop' : ''}`}
                                        src={project.image}
                                        alt={project.title}
                                        loading="lazy"
                                    />
                                </div>
                                <div
                                    className='project-card__face project-card__face--back'
                                    style={{ backgroundImage: `linear-gradient(135deg, rgba(0,0,0,0.25), rgba(0,0,0,0.6)), url(${vinyl})` }}
                                >
                                    <span>{project.title}</span>
                                </div>
                            </div>
                        </a>
                    </div>
                </SwiperSlide>
            ))}

        </Swiper>
    </div>
  )
}

export default Projects